export default __webpack_public_path__ + "static/media/leftDarkArrow.061f857b.svg";